import Vue from 'vue';
import ElementUI from 'element-ui';
import VueRouter from 'vue-router';

import VueQRCodeComponent from 'vue-qr-generator';
import locale from 'element-ui/lib/locale/lang/zh-TW';
import PlaceSelector from '@/components/PlaceSelector.vue';
import ProfessionalPickerVue from '@/components/ProfessionalPicker.vue';
import ProfessionalSelectorVue from '@/components/ProfessionalSelector.vue';
import AppointmentRoomView from '@/components/AppointmentRoomView.vue';
import ProBadge from '@/components/ProfessionalBadge.vue';
import UserPicker from '@/components/UserPicker.vue';
import Toggle from '@/components/input/Toggle.vue';
import misc from '@/plugins/misc';
import inputErr from '@/plugins/inputErr';
import msg from '@/plugins/enum';
import msgTable from '@/util/msg';

import EducationSelect from '@/components/input/EducationSelect.vue';
import RelationSelect from '@/components/input/RelationSelect.vue';
import ChatIDEditButton from '@/components/input/EditLINEChatButton.vue';

import App from './App.vue';
import routes from './router';
import { getForbiddenRedirect } from './router/access';
import store from './store';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/global.scss';

Vue.use(ElementUI, { locale });

Vue.component('qr-code', VueQRCodeComponent);

Vue.config.productionTip = false;
Vue.use(misc);
Vue.use(inputErr);
Vue.use(msg);
Vue.use(VueRouter);
Vue.component('place-selector', PlaceSelector);
Vue.component('pro-picker', ProfessionalPickerVue);
Vue.component('pro-selector', ProfessionalSelectorVue);
Vue.component('user-picker', UserPicker);
Vue.component('toggle', Toggle);
Vue.component('pro-badge', ProBadge);
Vue.component('appointment-room-view', AppointmentRoomView);
Vue.component('education-select', EducationSelect);
Vue.component('relation-select', RelationSelect);
Vue.component('line-chat-id-edit-button', ChatIDEditButton);

// window.mockMode = true;

const router = new VueRouter({
  routes,
});
// 頁面權限守衛：選單看不到的頁面，直接輸入網址也不能進入。
// 尚未取得登入資訊時（首次載入）先放行，由 App.vue 取得 profile 後再檢查一次。
router.beforeEach((to, from, next) => {
  if (!store.getters.isLogin) {
    next();
    return;
  }
  const redirect = getForbiddenRedirect(routes, to, store.getters.user.role);
  if (redirect === undefined) {
    next();
    return;
  }
  if (router.app && router.app.$showWarn) {
    router.app.$showWarn(msgTable.noPagePermission);
  }
  next(redirect);
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
